<template>
  <div class="truncate" :class="classes" v-html="value" />
</template>

<script>
export default {
  name: 'DateTimeFormatter',
  props: {
    dateTime: {
      type: String,
      required: true
    },
    format: {
      type: String,
      required: false,
      default: 'DD-MM-YYYY HH:mm'
    },
    classes: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    value() {
      if (this.dateTime === null || this.dateTime === '#######') {
        return ''
      }
      // return moment(this.dateTime).format(this.format)
      return this.dateTime
    }
  }
}
</script>

<style scoped></style>
